import axios from 'axios'
// import { Message } from 'element-ui';
import { Notify, Toast, Dialog } from 'vant'
import qs from 'qs'
import store from '../store'
import { getToken, removeToken, getVenueToken, removeVenueToken, setVenueToken } from '@/utils/auth'
import { encryptDes } from '@/utils/DES'
import * as uniWebView from '@/utils/uni_webview'
import { getVenueUserToken } from '@/api/venue.js'

// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.headers['Content-Type'] = 'application/json'
// axios.defaults.transformRequest = [
//   function (data, headers) {
//     return qs.stringify(data, { arrayFormat: 'indices', allowDots: true })
//   },
// ]
let loading
function startLoading() {
  loading = Toast.loading({
    message: '加载中...',
    forbidClick: true,
  })
}
function endLoading() {
  loading.clear()
}
// 创建axios实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_URL, // api 的 base_url // 设置了proxy后这边需要注释掉
  timeout: 1000 * 10, // 请求超时时间
  // 对 post put patch 进行转换
  //   transformRequest: [
  //     function (data, headers) {
  //       // return qs.stringify(data);
  //       // return qs.stringify(data, {indices: false});
  //       return qs.stringify(data, { arrayFormat: 'indices', allowDots: true })
  //     },
  //   ],
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    startLoading()
    console.log('config', config)
    let isVenueUser = config.url.indexOf('venueReservationApiServer') !== -1
    console.log('isVenueUser====>', isVenueUser)

    // const paramsData = config?.data || config?.params
    // if (store.getters.token) {
    //     config.headers['Authorization'] = 'Bearer ' + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    let token = !isVenueUser ? getToken() : getVenueToken()
    config.headers['token'] = token || ''

    // config.headers['token'] = getToken()
    // config.headers['sign'] = Math.floor((Math.random()*100000000)+1) + '' + new Date().getTime()
    // DES 加密
    // config.headers['sign'] = encryptDes(JSON.stringify(paramsData))
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  (error) => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// 请求全局拦截器
service.interceptors.response.use(
  (response) => {
    endLoading()
    const res = response.data
    console.log('res====>', res)
    if (res.code !== 2000) {
      if (res.code == 5104) {
        uniWebView.navigateTo({
          url: '/pages/login/index',
        })
        // Dialog.confirm({
        //   message: '您尚未登录，无法进行该操作！',
        //   confirmButtonText: '去登录',
        //   confirmButtonColor: '#a45d56',
        // })
        //   .then(() => {
        //     // on confirm
        //     uniWebView.reLaunch({
        //       url: '/pages/login/index',
        //     })
        //   })
        //   .catch(() => {
        //     // on cancel
        //   })
        return
      } else if (res.code == 5302) {
        Toast(res.message)
        uniWebView.navigateTo({
          url: '/pages/index/index',
        })
      } else if (res.code == 5106) {
        // 场馆token过期，需要重新调取
        if (getToken()) {
          removeVenueToken()
          getVenueUserToken().then((res) => {
            if (res.code == 2000) {
              setVenueToken(res.result.userToken)
              // 通知app修改场馆token
              uniWebView.postMessage({
                data: {
                  methodsName: 'UNISetVenueToken',
                  data: {
                    venueToken: res.result.userToken,
                  },
                },
              })
            }
          })
        } else {
          uniWebView.navigateTo({
            url: '/pages/login/index',
          })
        }
      } else {
        if (res.code !== 5216 && res.code !== 5219) {
          Toast(res.message)
        } else {
          return Promise.resolve(res)
        }
      }
    }

    return res
  },
  (error) => {
    endLoading()
    // alert(error)
    if (error.response) {
      // 服务器正常返回 http code，但是不是 2xx 区段
      Toast('系统繁忙，请稍后重试')
    } else if (error.request) {
      // 服务区未响应
      Toast('系统繁忙，请稍后重试')
    } else {
      // 一些由于其他原因（比如配置）导致的错误
      Toast('系统繁忙，请稍后重试')
    }

    return Promise.reject(error)
  }
)

export default service
